<template>
  <div class="lp-root">
    <!-- Fixed header wrapper -->
    <div class="lp-header" :class="{ 'lp-header-scrolled': scrolled }">
      <div class="lp-topbar">
        <span>🔥</span>
        <span>OFERTA LIMITADA · 50% OFF nos 3 primeiros meses</span>
        <span class="lp-countdown">
          {{ pad(countdown.d) }} : {{ pad(countdown.h) }} : {{ pad(countdown.m) }} : {{ pad(countdown.s) }}
        </span>
      </div>
      <nav class="lp-nav">
        <div class="lp-brand">
          <img :src="logoSrc" alt="VSLBooster" class="lp-logo-img" />
        </div>
        <div class="lp-nav-links">
          <a href="#recursos">Recursos</a>
          <a href="#como-funciona">Como funciona</a>
          <a href="#planos">Planos</a>
          <a href="#depoimentos">Depoimentos</a>
          <a href="/blog">Blog</a>
          <a href="#faq">FAQ</a>
        </div>
        <div class="lp-nav-ctas">
          <a href="/login" class="lp-btn-ghost">Entrar</a>
          <a href="/cadastro-trial" class="lp-btn-primary lp-btn-sm">Começar grátis →</a>
        </div>
        <button class="lp-hamburger" @click="mobileMenuOpen = !mobileMenuOpen" aria-label="Menu">
          <span :class="['lp-ham-line', mobileMenuOpen && 'lp-ham-open-1']"></span>
          <span :class="['lp-ham-line', mobileMenuOpen && 'lp-ham-open-2']"></span>
          <span :class="['lp-ham-line', mobileMenuOpen && 'lp-ham-open-3']"></span>
        </button>
      </nav>
      <div v-if="mobileMenuOpen" class="lp-mobile-menu">
        <a href="#recursos" @click="mobileMenuOpen=false">Recursos</a>
        <a href="#como-funciona" @click="mobileMenuOpen=false">Como funciona</a>
        <a href="#planos" @click="mobileMenuOpen=false">Planos</a>
        <a href="#depoimentos" @click="mobileMenuOpen=false">Depoimentos</a>
        <a href="/blog" @click="mobileMenuOpen=false">Blog</a>
        <a href="#faq" @click="mobileMenuOpen=false">FAQ</a>
        <a href="/login" class="lp-btn-ghost lp-mob-btn" @click="mobileMenuOpen=false">Entrar</a>
        <a href="/cadastro-trial" class="lp-btn-primary lp-mob-btn" @click="mobileMenuOpen=false">Começar grátis →</a>
      </div>
    </div>

    <!-- Spacer para compensar o header fixo -->
    <div class="lp-header-spacer" :style="{ height: scrolled ? '72px' : '116px' }"></div>

    <!-- HERO -->
    <section class="lp-hero">
      <div class="lp-hero-glow"></div>
      <div class="lp-hero-copy">
        <div class="lp-live-pill">
          <span class="lp-live-dot"></span>
          AO VIVO · 3.400+ VSLs rodando agora
        </div>
        <h1 class="lp-h1">
          Pare de perder<br />
          <span :style="gradientStyle">72% dos seus leads</span><br />
          no minuto 3.
        </h1>
        <p class="lp-hero-sub">
          Descubra <b>em qual segundo</b> o lead abandona a sua VSL, onde ele
          clica e <b class="lp-gold">exatamente o que otimizar</b> para
          converter 3x mais. Sem adivinhação.
        </p>
        <div class="lp-hero-cta">
          <a href="/cadastro-trial" class="lp-btn-primary lp-btn-lg">
            COMEÇAR GRÁTIS POR 30 DIAS →
          </a>
          <a href="#demo" class="lp-btn-ghost lp-btn-lg">▶ Ver demo (2min)</a>
        </div>
        <div class="lp-social">
          <div class="lp-avatars">
            <span
              v-for="(c, i) in avatarColors"
              :key="i"
              class="lp-avatar"
              :style="{ background: c, marginLeft: i === 0 ? 0 : '-8px' }"
            ></span>
          </div>
          <span>⭐⭐⭐⭐⭐ <b>4.9/5</b> · +12.400 empreendedores</span>
        </div>
      </div>

      <div class="lp-hero-mockup">
        <div class="lp-mock lp-mock-dash">
          <div class="lp-mock-bar">
            <span class="lp-dot lp-dot-r"></span>
            <span class="lp-dot lp-dot-y"></span>
            <span class="lp-dot lp-dot-g"></span>
            <span class="lp-mock-title">VSL · Oferta Janeiro</span>
          </div>
          <div class="lp-mock-body">
            <div class="lp-kpis">
              <div class="lp-kpi">
                <div class="lp-kpi-label">Play rate</div>
                <div class="lp-kpi-value">68.4%</div>
                <div class="lp-kpi-delta lp-up">↑ 12%</div>
              </div>
              <div class="lp-kpi">
                <div class="lp-kpi-label">Retenção</div>
                <div class="lp-kpi-value">42.1%</div>
                <div class="lp-kpi-delta lp-up">↑ 47%</div>
              </div>
              <div class="lp-kpi">
                <div class="lp-kpi-label">CTR</div>
                <div class="lp-kpi-value">8.9%</div>
                <div class="lp-kpi-delta lp-up">↑ 3.2%</div>
              </div>
            </div>
            <div class="lp-chart">
              <svg viewBox="0 0 400 120" preserveAspectRatio="none">
                <defs>
                  <linearGradient id="lpGrad" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stop-color="#E86A10" stop-opacity="0.35" />
                    <stop offset="100%" stop-color="#E86A10" stop-opacity="0" />
                  </linearGradient>
                </defs>
                <path d="M0,40 L40,35 L80,45 L120,30 L160,50 L200,42 L240,60 L280,75 L320,90 L360,100 L400,108 L400,120 L0,120 Z" fill="url(#lpGrad)" />
                <path d="M0,40 L40,35 L80,45 L120,30 L160,50 L200,42 L240,60 L280,75 L320,90 L360,100 L400,108" fill="none" stroke="#E86A10" stroke-width="2" />
              </svg>
            </div>
          </div>
        </div>

        <div class="lp-mock lp-mock-heat lp-mock-player">
          <div>[vid_85e561f4bc9acb5043d36b49f50b4c15]</div>
        </div>

        <div class="lp-badge lp-badge-ret">+47% retenção <span class="lp-up">↑</span></div>
        <div class="lp-badge lp-badge-rev">R$ 2,3MM gerados</div>
      </div>
    </section>

    <!-- LOGOS -->
    <div class="lp-logos">
      <span class="lp-logos-label">USADO POR:</span>
      <span v-for="l in logos" :key="l" class="lp-logo-brand">{{ l }}</span>
    </div>

    <!-- PROBLEM -->
    <section class="lp-section lp-section-alt" id="recursos">
      <div class="lp-section-head" style="text-align:center">
        <span class="lp-pill lp-pill-red">⚠ O problema</span>
        <h2 class="lp-h2" style="text-align:center">
          Todo dia que você não sabe<br />onde seu lead desiste,
          <span class="lp-gold">é dinheiro jogado fora.</span>
        </h2>
      </div>
      <div class="lp-grid-3">
        <div v-for="p in problems" :key="p.tag" class="lp-card lp-card-prob">
          <div class="lp-card-bignum">{{ p.tag }}</div>
          <div class="lp-card-icon lp-icon-red">✕</div>
          <h3 class="lp-card-title">{{ p.t }}</h3>
          <p class="lp-card-body">{{ p.d }}</p>
        </div>
      </div>
    </section>

    <!-- SOLUÇÃO — 7 módulos com tabs -->
    <section class="lp-section" id="solucao">
      <div class="lp-section-head" style="text-align:center">
        <span class="lp-pill lp-pill-gold">★ A solução</span>
        <h2 class="lp-h2" style="text-align:center">
          O VSLBooster e o painel de controle<br />da <span class="lp-gold">sua VSL</span>
        </h2>
        <p class="lp-section-sub">
          7 ferramentas que trabalham juntas para transformar cada visualização em venda.
        </p>
      </div>

      <div class="lp-mods-tabs">
        <button
          v-for="(mod, i) in modules"
          :key="mod.id"
          class="lp-mods-tab"
          :class="{ active: i === activeModule }"
          :style="i === activeModule ? { borderColor: mod.accent, boxShadow: '0 10px 30px ' + mod.accent + '22' } : {}"
          @click="activeModule = i"
        >
          <span class="lp-mods-tab-icon" :style="{ background: mod.accent + '22', borderColor: mod.accent + '55' }">{{ mod.icon }}</span>
          <span class="lp-mods-tab-name" :class="{ active: i === activeModule }">{{ mod.name }}</span>
        </button>
      </div>

      <div class="lp-mods-panel">
        <div class="lp-mods-glow" :style="{ background: 'radial-gradient(circle,' + activeMod.accent + '22,transparent 70%)' }"></div>
        <div class="lp-mods-content">
          <div class="lp-mods-pill" :style="{ background: activeMod.accent + '18', borderColor: activeMod.accent + '55', color: activeMod.accent }">
            MÓDULO {{ activeMod.num }} · {{ activeMod.name }}
          </div>
          <h3 class="lp-mods-title">{{ activeMod.title }}</h3>
          <p class="lp-mods-desc">{{ activeMod.desc }}</p>
          <ul class="lp-mods-bullets">
            <li v-for="(b, j) in activeMod.bullets" :key="j">
              <span class="lp-mods-check" :style="{ color: activeMod.accent }">✓</span>{{ b }}
            </li>
          </ul>
          <div class="lp-mods-footer" :style="{ background: activeMod.accent + '12', borderColor: activeMod.accent + '44' }">
            <span :style="{ color: activeMod.accent }">★</span>{{ activeMod.footer }}
          </div>
        </div>
        <div class="lp-mods-mockup-wrap">
          <div class="lp-mods-mockup">
            <div class="lp-mods-mockup-bar" :style="{ background: activeMod.accent, color: activeMod.isLight ? '#1a1405' : '#fff' }">
              <span class="lp-mods-mockup-icon">{{ activeMod.icon }}</span>
              {{ activeMod.mockupTitle }}
            </div>
            <div class="lp-mods-mockup-body">
              <div class="lp-mods-bars">
                <div class="lp-mods-bar" :style="{ background: activeMod.accent + '55', width: '90%' }"></div>
                <div class="lp-mods-bar" :style="{ background: activeMod.accent + '33', width: '70%' }"></div>
                <div class="lp-mods-bar" :style="{ background: activeMod.accent + '22', width: '80%' }"></div>
                <div class="lp-mods-bar" :style="{ background: activeMod.accent + '22', width: '55%' }"></div>
              </div>
              <div class="lp-mods-stats">
                <div v-for="(s, j) in activeMod.stats" :key="j" class="lp-mods-stat">
                  <div class="lp-mods-stat-v" :style="{ color: activeMod.accent }">{{ s.v }}</div>
                  <div class="lp-mods-stat-l">{{ s.l }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- HOW IT WORKS -->
    <section class="lp-section lp-section-alt" id="como-funciona">
      <div class="lp-section-head" style="text-align:center">
        <span class="lp-pill lp-pill-orange">★ Como funciona</span>
        <h2 class="lp-h2" style="text-align:center">
          Em <span class="lp-gold">5 minutos</span> você troca o achismo por dados.
        </h2>
      </div>
      <div class="lp-grid-3">
        <div v-for="(s, i) in steps" :key="s.n" class="lp-card" :class="{ 'lp-card-feat': i === 1 }">
          <div class="lp-step-num">{{ s.n }}</div>
          <h3 class="lp-card-title">{{ s.t }}</h3>
          <p class="lp-card-body">{{ s.d }}</p>
        </div>
      </div>
    </section>

    <!-- TESTIMONIALS -->
    <section class="lp-section" id="depoimentos">
      <div class="lp-section-head" style="text-align:center">
        <span class="lp-pill lp-pill-green">★ Depoimentos</span>
        <h2 class="lp-h2" style="text-align:center">Resultados reais de <span class="lp-gold">quem parou de adivinhar.</span></h2>
      </div>
      <div class="lp-grid-3">
        <div v-for="t in testimonials" :key="t.n" class="lp-card">
          <div class="lp-t-head">
            <div class="lp-t-avatar" :style="{ background: t.a }">
              {{ t.n.split(' ').map(function(x) { return x[0] }).slice(0, 2).join('') }}
            </div>
            <div>
              <div class="lp-t-name">{{ t.n }}</div>
              <div class="lp-t-role">{{ t.r }}</div>
            </div>
            <div class="lp-t-stars">★★★★★</div>
          </div>
          <div class="lp-t-metric">
            <span class="lp-t-metric-v">{{ t.metric }}</span>
            <span class="lp-t-metric-l">{{ t.metricLabel }}</span>
          </div>
          <p class="lp-t-quote">"{{ t.quote }}"</p>
        </div>
      </div>
    </section>

    <!-- PRICING -->
    <section class="lp-section lp-section-alt" id="planos">
      <div class="lp-section-head" style="text-align:center">
        <span class="lp-pill lp-pill-gold">⚡ Oferta por tempo limitado</span>
        <h2 class="lp-h2" style="text-align:center">Escolha seu plano e <span class="lp-gold">comece hoje.</span></h2>
        <p class="lp-section-sub">30 dias grátis. Cancele a qualquer momento.</p>
      </div>
      <div class="lp-pricing">
        <div v-for="p in plans" :key="p.n" class="lp-price-card" :class="{ 'lp-price-feat': p.feat }">
          <div v-if="p.feat" class="lp-price-badge">🏆 MAIS ESCOLHIDO</div>
          <h3 class="lp-price-name">{{ p.n }}</h3>
          <div class="lp-price-old">R$ {{ p.po }}/mês</div>
          <div class="lp-price-value">
            <span class="lp-price-curr">R$</span>
            <span class="lp-price-num">{{ p.p }}</span>
            <span class="lp-price-per">/mês</span>
          </div>
          <ul class="lp-price-feats">
            <li v-for="(f, j) in p.f" :key="j"><span class="lp-check">✓</span>{{ f }}</li>
          </ul>
          <a href="/cadastro-trial" class="lp-price-cta">Começar grátis →</a>
        </div>
      </div>
    </section>

    <!-- FAQ -->
    <section class="lp-section" id="faq">
      <div class="lp-faq-grid">
        <div>
          <span class="lp-pill lp-pill-orange">? Dúvidas</span>
          <h2 class="lp-h2" style="text-align:center">Perguntas frequentes</h2>
          <p class="lp-faq-sub">Não achou sua dúvida? Fale com a gente no chat — resposta em menos de 2 minutos em horário comercial.</p>
        </div>
        <div class="lp-faq-list">
          <details v-for="(f, i) in faqs" :key="i" :open="i === 0" class="lp-faq-item">
            <summary>{{ f.q }}<span class="lp-faq-plus">+</span></summary>
            <p>{{ f.a }}</p>
          </details>
        </div>
      </div>
    </section>

    <!-- FINAL CTA -->
    <section class="lp-final">
      <div class="lp-final-glow"></div>
      <div class="lp-final-inner">
        <h2 class="lp-final-h">Cada dia sem dados<br /><span class="lp-gold">é dinheiro perdido.</span></h2>
        <p class="lp-final-sub">30 dias grátis. Setup em 5 minutos. Cancele quando quiser.</p>
        <a href="/cadastro-trial" class="lp-btn-primary lp-btn-lg">COMEÇAR GRÁTIS POR 30 DIAS →</a>
      </div>
    </section>

    <!-- FOOTER -->
    <footer class="lp-footer">
      <div class="lp-footer-brand">
        <img :src="logoSrc" alt="VSLBooster" class="lp-logo-img" />
        <span>© 2026 VSLBooster. Todos os direitos reservados.</span>
      </div>
      <div class="lp-footer-links">
        <a href="#">Termos</a>
        <a href="#">Privacidade</a>
        <a href="#">Contato</a>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  data() {
    return {
      now: Date.now(),
      deadline: 0,
      timer: null,
      activeModule: 0,
      logoSrc: require('@/assets/images/logo/vslbooster-logo-dark.svg'),
      gradientStyle: {
        background: 'linear-gradient(90deg, #e86a10, #f5b935)',
        '-webkit-background-clip': 'text',
        '-webkit-text-fill-color': 'transparent',
        'background-clip': 'text',
        color: 'transparent',
        display: 'inline-block',
      },
      mobileMenuOpen: false,
      scrolled: false,
      avatarColors: ['#E86A10', '#318feb', '#28c76f', '#8b5cf6', '#F5B935'],
      logos: ['HOTFUNNEL', 'LEADGEN.CO', 'ORTO+', 'METRIKA', 'BIGSALE', 'CONVERSA'],
      modules: [
        {
          id: 'player', num: '01', name: 'PLAYER VSL', accent: '#E86A10', icon: '▶',
          mockupTitle: 'Player VSL',
          title: 'Pare de perder leads que pulam direto pro final',
          desc: 'Enquanto outros players só dão play, o VSLBooster controla o que o lead pode pular, quando o CTA aparece e onde ele parou da última vez.',
          bullets: [
            'Anti-skip: impede que pulem direto pro final, seu roteiro inteiro é assistido',
            'Continuar assistindo: retoma de onde parou, nenhum lead perde o fio da meada',
            'Botões de ação com timer, aparecem quando a dor do lead está no pico',
            'Autoplay híbrido, funciona em qualquer navegador, sem travar',
            'Progresso inteligente que esconde quanto falta, mantém o lead até o final',
            'Thumbnails de início, pausa e fim customizáveis, sua marca em cada interação',
          ],
          stats: [{ v: '92%', l: 'RETENÇÃO' }, { v: '0%', l: 'SKIP RATE' }, { v: '+47%', l: 'WATCH TIME' }],
          footer: 'Baseado em 3.400+ VSLs ativas na plataforma nos últimos 12 meses',
        },
        {
          id: 'chat', num: '02', name: 'CHAT COM IA', accent: '#8B5CF6', icon: '💬',
          mockupTitle: 'Chat Booster',
          title: 'Seu lead tem dúvidas enquanto assiste. Responda antes que ele feche a aba',
          desc: 'Um chat com IA conversa com o lead em tempo real enquanto o vídeo roda. Responde objeções, captura nome, email e WhatsApp e empurra pra ação.',
          bullets: [
            'Fluxos de mensagem automatizados e personalizáveis',
            'IA que responde dúvidas sobre o produto em tempo real',
            'Captura de lead (nome, email, WhatsApp) dentro do chat',
            'Integração com RD Station, PipeDrive e Active Campaign',
            'Dashboard de leads com histórico de conversa',
            'Design do chat 100% customizável',
          ],
          stats: [{ v: '3x', l: 'LEADS CAPTURADOS' }, { v: '89%', l: 'TAXA RESPOSTA' }, { v: '+200', l: 'LEADS/MÊS' }],
          footer: 'Chat com IA integrado direto no player. Exclusivo VSLBooster',
        },
        {
          id: 'webinar', num: '03', name: 'WEBINÁRIO AO VIVO', accent: '#318feb', icon: '📡',
          mockupTitle: 'Webinário',
          title: 'Grave uma vez. Transmita ao vivo quantas vezes quiser.',
          desc: 'Grave seu webinar uma vez e transmita ao vivo quantas vezes quiser. O lead assiste como se fosse ao vivo, com chat, urgência e escassez real.',
          bullets: [
            'Transmissão real de vídeo gravado como se fosse ao vivo',
            'Agendamento com data, hora e fuso horário',
            'Indicador "AO VIVO" durante a transmissão',
            'Chat em tempo real com mensagens programadas',
            'Escassez real: só pode assistir no horário agendado',
            'Grave uma vez, repita infinitas vezes sem esforço',
          ],
          stats: [{ v: '4x', l: 'VS ON-DEMAND' }, { v: '96%', l: 'PRESENÇA' }, { v: '78%', l: 'ATÉ O FINAL' }],
          footer: 'Grave 1 vez, transmita ao vivo infinitas vezes',
        },
        {
          id: 'heatmap', num: '04', name: 'MAPA DE CALOR', accent: '#28C76F', icon: '🔥',
          mockupTitle: 'Heatmap',
          title: 'Seu botão de compra pode estar numa zona morta da página',
          desc: 'O heatmap mostra exatamente onde seu lead clica e até onde ele desce na página. Identifique CTAs invisíveis, áreas mortas e o que está roubando atenção.',
          bullets: [
            'Heatmap de cliques: onde o lead toca na página',
            'Scroll depth: até onde a maioria desce',
            'Filtro por data para comparar períodos',
            'Identifica CTAs invisíveis e áreas mortas',
            'Funciona em qualquer página, não só no player',
            'Dados visuais, sem precisar interpretar números',
          ],
          stats: [{ v: '12', l: 'ZONAS MORTAS' }, { v: '34%', l: 'SCROLL DEPTH' }, { v: '8', l: 'CTAS OCULTOS' }],
          footer: 'Heatmap + player + chat na mesma plataforma',
        },
        {
          id: 'drm', num: '05', name: 'DRM & PROTEÇÃO', accent: '#FF5A6B', icon: '🔒',
          mockupTitle: 'DRM Proteção',
          title: 'Seu conteúdo só quem pagou assiste',
          desc: 'Bloqueio de download + marca d\'água com dados do usuário. Se o vídeo vazar, você sabe exatamente quem compartilhou. Proteção real, não só um aviso.',
          bullets: [
            'Bloqueio de download nativo (anti-pirataria)',
            'Marca d\'água rastreável com dados do espectador',
            'Identificação automática de quem vazou o conteúdo',
            'Proteção contra gravação de tela',
            'Anti-skip integrado ao player',
            'Controle de acesso por domínio',
          ],
          stats: [{ v: '0%', l: 'DOWNLOADS' }, { v: '100%', l: 'RASTREÁVEL' }, { v: '24h', l: 'DETECÇÃO' }],
          footer: 'DRM com marca d\'água rastreável. Exclusivo VSLBooster',
        },
        {
          id: 'legendas', num: '06', name: 'LEGENDAS COM IA', accent: '#06B6D4', icon: '💭',
          mockupTitle: 'Legendas IA',
          title: '80% dos vídeos são assistidos sem som',
          desc: 'Ative legendas automáticas no upload. Geradas por IA em segundos, sincronizadas quadro a quadro. Mais atenção, mais retenção, mais vendas.',
          bullets: [
            'Legendas geradas automaticamente por IA (Whisper)',
            'Sincronização precisa quadro a quadro',
            'Cores e estilo customizáveis no painel',
            'Suporte a português, inglês e espanhol',
            'Ativação com um clique no editor',
            'Aumenta retenção em até 40% (dados internos)',
          ],
          stats: [{ v: '+40%', l: 'RETENÇÃO' }, { v: '3s', l: 'GERAÇÃO' }, { v: '99%', l: 'PRECISÃO' }],
          footer: 'Legendas com IA integradas direto no player',
        },
        {
          id: 'analytics', num: '07', name: 'ANALYTICS COM IA', accent: '#F5B935', icon: '📊', isLight: true,
          mockupTitle: 'Analytics IA',
          title: '"Mova o CTA para 3:45 → +12% de conversão estimada"',
          desc: 'A IA analisa a retenção segundo a segundo e te diz exatamente o que fazer. Não é só dado, é direção.',
          bullets: [
            'Retenção por segundo: veja onde o lead abandona',
            'Funil completo: carregou → assistiu → clicou no CTA',
            'Pico de abandono destacado automaticamente',
            'Sugestões da IA: "mova o CTA para 3:45"',
            'Play rate, completion rate, click-through rate',
            'Comparação entre vídeos e períodos',
          ],
          stats: [{ v: '+31%', l: 'CONVERSÃO' }, { v: '3:45', l: 'CTA IDEAL' }, { v: '12%', l: 'GANHO ESTIMADO' }],
          footer: 'IA que sugere otimizações automaticamente',
        },
      ],
      problems: [
        { tag: '01', t: 'Sem visibilidade', d: 'Você não sabe em qual segundo o lead abandona. Está otimizando a VSL no escuro.' },
        { tag: '02', t: 'Dinheiro no tráfego', d: 'Gasta R$ mil/dia em anúncios mas não sabe onde a VSL perde o lead — nem o que mudar.' },
        { tag: '03', t: 'Decisões no achismo', d: 'Muda headline, CTA, oferta… baseado em chute. E o play rate continua o mesmo.' },
      ],
      steps: [
        { n: 1, t: 'Cole o código no seu site', d: 'Um snippet de 3 linhas. Funciona em qualquer landing, qualquer plataforma.' },
        { n: 2, t: 'Deixe o VSLBooster rodar', d: 'Cada play, pausa, rewind e clique vira dado. Heatmap em tempo real.' },
        { n: 3, t: 'Otimize o que gera R$', d: 'Veja o segundo exato que perde o lead. Troque. Converta 3x mais.' },
      ],
      testimonials: [
        { n: 'Bruno Menezes', r: 'Infoprodutor · Nicho Fitness', a: '#E86A10', metric: '+218%', metricLabel: 'em conversão', quote: 'Descobri que 68% dos meus leads saíam no minuto 2:40. Troquei a headline e o play rate de fim dobrou em 2 semanas.' },
        { n: 'Letícia Ramos', r: 'Agência de Tráfego', a: '#318feb', metric: 'R$ 340k', metricLabel: 'economizados em ads', quote: 'Parei de queimar verba em VSLs que não convertiam. Agora só escalo o que o VSLBooster valida. Simples assim.' },
        { n: 'Rafael Costa', r: 'E-commerce · Suplementos', a: '#28C76F', metric: '3.4x', metricLabel: 'mais vendas', quote: 'O heatmap mostrou que ninguém clicava no CTA do meio. Movi pra baixo e triplicou. Ficou óbvio depois que vi o dado.' },
      ],
      plans: [
        { n: 'Starter', p: '47', po: '94', f: ['5 VSLs ativas', 'Analytics em tempo real', 'Chat de captura', 'Suporte por email'], feat: false },
        { n: 'Pro', p: '97', po: '194', f: ['25 VSLs ativas', 'Tudo do Starter', 'Heatmap de cliques', 'Webinar simulado', 'Chamada inteligente (CTA)', 'Geração de legenda automaticamente', 'Suporte prioritário'], feat: true },
        { n: 'Business', p: '197', po: '394', f: ['VSLs ilimitadas', 'Tudo do Pro', 'API de integração', 'Gerente dedicado'], feat: false },
      ],
      faqs: [
        { q: 'Preciso instalar algo no meu site?', a: 'Só um snippet de 3 linhas de JavaScript antes do </body>. Funciona em WordPress, Shopify, Wix, HTML puro — qualquer plataforma.' },
        { q: 'Funciona com qual player de vídeo?', a: 'Funciona com todos os principais: VTurb, Panda Video, Vimeo, YouTube, HLS direto e players próprios. Se usa <video>, a gente mede.' },
        { q: 'Posso cancelar quando quiser?', a: 'Sim. Sem fidelidade, sem multa. Cancela direto no painel em 1 clique. Os 30 dias iniciais são 100% grátis, sem cartão exigido.' },
        { q: 'Meus dados ficam seguros?', a: 'Servidores no Brasil (LGPD), criptografia em trânsito e em repouso. Você é o dono dos dados — exporte ou delete a qualquer momento.' },
        { q: 'Vocês têm suporte em português?', a: '100%. Time brasileiro, chat ao vivo em horário comercial e base de conhecimento completa. Plano Pro+ tem suporte prioritário.' },
      ],
    }
  },
  computed: {
    activeMod() {
      return this.modules[this.activeModule]
    },
    countdown() {
      const diff = Math.max(0, this.deadline - this.now)
      return {
        d: Math.floor(diff / 86400000),
        h: Math.floor((diff % 86400000) / 3600000),
        m: Math.floor((diff % 3600000) / 60000),
        s: Math.floor((diff % 60000) / 1000),
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!document.querySelector('script[data-booster]')) {
        const s = document.createElement('script')
        s.src = 'https://vslbooster.com/js/booster.min.js'
        s.setAttribute('data-booster', '5d0697d2-fa5c-4e33-a56f-9f055d6f8c515')
        s.async = true
        document.body.appendChild(s)
      } else if (window.VSLBooster && window.VSLBooster.init) {
        window.VSLBooster.init()
      }
    })

    const saved = sessionStorage.getItem('vslb_deadline')
    if (saved) {
      this.deadline = parseInt(saved)
    } else {
      this.deadline = Date.now() + (2 * 86400 + 14 * 3600 + 38 * 60 + 9) * 1000
      sessionStorage.setItem('vslb_deadline', String(this.deadline))
    }
    this.timer = setInterval(() => { this.now = Date.now() }, 1000)
    this._onScroll = () => { this.scrolled = window.scrollY > 60 }
    window.addEventListener('scroll', this._onScroll, { passive: true })
  },
  beforeDestroy() {
    clearInterval(this.timer)
    window.removeEventListener('scroll', this._onScroll)
  },
  methods: {
    pad(n) {
      return String(n).padStart(2, '0')
    },
  },
}
</script>

<!-- NÃO scoped — evita que [data-v-xxxx] quebre background-clip:text e outros vendor-prefix.
     Isolamento garantido pelo prefixo .lp-root em TODOS os seletores. -->
<style>
/* ── TOKENS ── */
.lp-root {
  --lp-orange: #e86a10;
  --lp-orange-deep: #c12b2b;
  --lp-gold: #f5b935;
  --lp-bg: #0a1018;
  --lp-bg-2: #0e1522;
  --lp-text: #ffffff;
  --lp-text-mute: rgba(255,255,255,0.7);
  --lp-text-dim: rgba(255,255,255,0.5);
  --lp-border: rgba(255,255,255,0.08);
  --lp-red: #ff5a6b;
  --lp-green: #28c76f;

  background: var(--lp-bg) !important;
  color: var(--lp-text) !important;
  font-family: "Inter", system-ui, -apple-system, sans-serif !important;
  min-height: 100vh;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
}

/* ── RESET DE HEADINGS DENTRO DO LP — anula Bootstrap/Vuexy $headings-color ── */
.lp-root h1,
.lp-root h2,
.lp-root h3,
.lp-root h4,
.lp-root h5,
.lp-root h6 {
  color: var(--lp-text) !important;
  font-weight: inherit;
  line-height: inherit;
  margin-bottom: 0;
}

.lp-root * { box-sizing: border-box; }
.lp-root a { color: inherit !important; text-decoration: none !important; }
.lp-root p { margin-bottom: 0; }

/* ── GRADIENT TEXT — sem scoped, background-clip:text funciona corretamente ── */
.lp-root .lp-gradient {
  background: linear-gradient(90deg, var(--lp-orange), var(--lp-gold)) !important;
  -webkit-background-clip: text !important;
  background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
  display: inline-block !important;
  padding: 0;
}

.lp-root .lp-gold { color: var(--lp-gold) !important; }
.lp-root .lp-up   { color: var(--lp-green) !important; }

/* ── BUTTONS ── */
.lp-root .lp-btn-primary {
  display: inline-flex; align-items: center; justify-content: center;
  padding: 12px 22px; background: var(--lp-orange) !important; color: #fff !important;
  border-radius: 10px; font-weight: 800 !important; font-size: 14px;
  box-shadow: 0 8px 24px rgba(232,106,16,0.45);
  transition: transform 0.15s, box-shadow 0.15s;
  border: none;
}
.lp-root .lp-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 12px 32px rgba(232,106,16,0.55); }
.lp-root .lp-btn-ghost {
  display: inline-flex; align-items: center; justify-content: center;
  padding: 11px 20px; color: #fff !important;
  border: 1.5px solid rgba(255,255,255,0.2) !important;
  border-radius: 10px; font-weight: 700 !important; font-size: 14px;
  background: transparent !important;
  transition: border-color 0.15s, background 0.15s;
}
.lp-root .lp-btn-ghost:hover { border-color: rgba(255,255,255,0.4) !important; background: rgba(255,255,255,0.03) !important; }
.lp-root .lp-btn-sm { padding: 11px 20px; font-size: 13.5px; }
.lp-root .lp-btn-lg { padding: 16px 28px; font-size: 16px; }

/* ── FIXED HEADER ── */
.lp-root .lp-header {
  position: fixed; top: 0; left: 0; right: 0; z-index: 200;
  background: var(--lp-bg);
  transition: box-shadow 0.3s ease, background 0.3s ease;
}
.lp-root .lp-header.lp-header-scrolled {
  box-shadow: 0 4px 24px rgba(0,0,0,0.5);
  background: rgba(10,13,18,0.97) !important;
  backdrop-filter: blur(12px);
}
.lp-root .lp-header-spacer { transition: height 0.35s ease; }

/* ── TOPBAR ── */
.lp-root .lp-topbar {
  display: flex; align-items: center; justify-content: center;
  gap: 14px; padding: 10px 24px;
  background: linear-gradient(90deg, var(--lp-orange), var(--lp-orange-deep)) !important;
  color: #fff !important; font-size: 13px; font-weight: 700; letter-spacing: 0.2px;
  flex-wrap: wrap;
  max-height: 60px; overflow: hidden;
  transition: max-height 0.35s ease, padding 0.35s ease, opacity 0.35s ease;
  opacity: 1;
}
.lp-root .lp-header-scrolled .lp-topbar {
  max-height: 0 !important; padding-top: 0 !important; padding-bottom: 0 !important; opacity: 0 !important;
}
.lp-root .lp-countdown {
  font-family: ui-monospace, "SF Mono", Menlo, monospace;
  background: rgba(0,0,0,0.3); padding: 3px 10px; border-radius: 6px;
  font-variant-numeric: tabular-nums;
}

/* ── NAV ── */
.lp-root .lp-nav {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px clamp(20px, 4vw, 60px);
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.lp-root .lp-brand { display: flex; align-items: center; gap: 10px; font-weight: 900; font-size: 19px; }
.lp-root .lp-logo-img { height: 40px; width: auto; display: block; }
.lp-root .lp-nav-links { display: flex; gap: 28px; font-size: 13.5px; color: rgba(255,255,255,0.65); font-weight: 500; }
.lp-root .lp-nav-links a:hover { color: #fff !important; }
.lp-root .lp-nav-ctas { display: flex; gap: 10px; }
@media (max-width: 900px) { .lp-root .lp-nav-links { display: none; } .lp-root .lp-nav-ctas { display: none; } }

/* ── HAMBURGER ── */
.lp-root .lp-hamburger {
  display: none; flex-direction: column; justify-content: center; gap: 5px;
  background: none; border: none; cursor: pointer; padding: 6px; z-index: 200;
}
.lp-root .lp-ham-line {
  display: block; width: 24px; height: 2px;
  background: #fff; border-radius: 2px;
  transition: transform 0.25s, opacity 0.25s;
}
.lp-root .lp-ham-open-1 { transform: translateY(7px) rotate(45deg); }
.lp-root .lp-ham-open-2 { opacity: 0; }
.lp-root .lp-ham-open-3 { transform: translateY(-7px) rotate(-45deg); }
@media (max-width: 900px) { .lp-root .lp-hamburger { display: flex; } }

/* ── MOBILE MENU ── */
.lp-root .lp-mobile-menu {
  display: flex; flex-direction: column; gap: 4px;
  padding: 16px 24px 20px;
  background: var(--lp-bg-2);
  border-bottom: 1px solid rgba(255,255,255,0.08);
}
.lp-root .lp-mobile-menu a {
  padding: 12px 0; font-size: 15px; font-weight: 600;
  color: rgba(255,255,255,0.75) !important;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  text-decoration: none !important;
}
.lp-root .lp-mobile-menu a:last-child { border-bottom: none; }
.lp-root .lp-mob-btn {
  margin-top: 8px; text-align: center; border-radius: 10px !important;
  padding: 13px 20px !important; font-size: 14px !important;
}

/* ── HERO ── */
.lp-root .lp-hero {
  position: relative; padding: 60px clamp(20px, 4vw, 60px) 70px;
  display: grid; grid-template-columns: 1.05fr 1fr; gap: 40px; align-items: center;
}
.lp-root .lp-hero-glow {
  position: absolute; top: -80px; left: -120px; width: 520px; height: 520px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(232,106,16,0.25), transparent 65%);
  pointer-events: none;
}
.lp-root .lp-hero-copy { position: relative; }
.lp-root .lp-live-pill {
  display: inline-flex; align-items: center; gap: 8px; padding: 6px 14px;
  background: rgba(232,106,16,0.12); border: 1px solid rgba(232,106,16,0.3);
  border-radius: 999px; font-size: 12px; font-weight: 800; color: var(--lp-orange) !important;
  letter-spacing: 0.3px; margin-bottom: 20px;
}
.lp-root .lp-live-dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: var(--lp-orange); box-shadow: 0 0 10px var(--lp-orange);
  animation: lp-pulse 1.5s ease-in-out infinite;
}
@keyframes lp-pulse { 50% { opacity: 0.4; } }

.lp-root .lp-h1 {
  font-size: clamp(40px, 5vw, 64px) !important;
  font-weight: 900 !important;
  line-height: 0.98 !important;
  letter-spacing: -2.5px;
  margin: 0 0 20px !important;
  color: var(--lp-text) !important;
}
.lp-root .lp-hero-sub {
  font-size: 18px; line-height: 1.5; color: var(--lp-text-mute) !important;
  margin: 0 0 28px; max-width: 520px;
}
.lp-root .lp-hero-sub b { color: #fff !important; }
.lp-root .lp-hero-cta { display: flex; gap: 12px; margin-bottom: 20px; flex-wrap: wrap; }
.lp-root .lp-social { display: flex; align-items: center; gap: 10px; font-size: 12px; color: var(--lp-text-dim); }
.lp-root .lp-social b { color: #fff !important; }
.lp-root .lp-avatars { display: flex; }
.lp-root .lp-avatar { width: 28px; height: 28px; border-radius: 50%; border: 2px solid var(--lp-bg); display: inline-block; }
@media (max-width: 900px) {
  .lp-root .lp-hero { grid-template-columns: 1fr; }
  .lp-root .lp-hero-cta { flex-direction: column; }
  .lp-root .lp-hero-cta a { text-align: center; width: 100%; box-sizing: border-box; }
  .lp-root .lp-mock-dash { display: none; }
  .lp-root .lp-badge { display: none; }
  .lp-root .lp-hero-mockup {
    position: static;
    width: 100%;
    height: auto;
    min-height: unset;
  }
  .lp-root .lp-mock-player {
    position: static !important;
    width: 100% !important;
    transform: none !important;
    border-radius: 12px;
  }
}
@media (max-width: 480px) {
  .lp-root .lp-topbar { font-size: 11px; gap: 8px; padding: 8px 16px; }
  .lp-root .lp-countdown { font-size: 11px; }
  .lp-root .lp-topbar > span:first-child { display: none; }
}

/* ── HERO MOCKUP ── */
.lp-root .lp-hero-mockup { position: relative; height: 420px; }
.lp-root .lp-mock {
  position: absolute; background: #0F1724;
  border: 1px solid rgba(255,255,255,0.08); border-radius: 12px;
  overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,0.5);
}
.lp-root .lp-mock-dash { top: 10px; left: 0; width: 420px; transform: rotate(-2deg); }
.lp-root .lp-mock-heat { bottom: 60px; right: -20px; width: 440px; transform: rotate(3deg); z-index: 2; }
.lp-root .lp-mock-player { padding: 0 !important; overflow: hidden; border-radius: 10px; }
.lp-root .lp-mock-player > div { display: block; width: 100%; }
.lp-root .lp-mock-bar {
  display: flex; align-items: center; gap: 6px; padding: 10px 14px;
  border-bottom: 1px solid rgba(255,255,255,0.06); background: rgba(0,0,0,0.2);
}
.lp-root .lp-dot { width: 10px; height: 10px; border-radius: 50%; }
.lp-root .lp-dot-r { background: #FF5A6B; }
.lp-root .lp-dot-y { background: #F5B935; }
.lp-root .lp-dot-g { background: #28C76F; }
.lp-root .lp-mock-title { margin-left: 10px; font-size: 11px; color: var(--lp-text-dim); font-weight: 600; }
.lp-root .lp-mock-body { padding: 16px; }
.lp-root .lp-kpis { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin-bottom: 14px; }
.lp-root .lp-kpi { padding: 10px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.05); border-radius: 8px; }
.lp-root .lp-kpi-label { font-size: 10px; color: var(--lp-text-dim); margin-bottom: 2px; }
.lp-root .lp-kpi-value { font-size: 18px; font-weight: 900; letter-spacing: -0.5px; color: var(--lp-text) !important; }
.lp-root .lp-kpi-delta { font-size: 10px; font-weight: 700; margin-top: 2px; }
.lp-root .lp-chart { height: 80px; background: rgba(0,0,0,0.2); border-radius: 6px; padding: 4px; }
.lp-root .lp-chart svg { width: 100%; height: 100%; }
.lp-root .lp-heat-body { padding: 12px; }
.lp-root .lp-heat-video { position: relative; background: #1a1f2e; aspect-ratio: 16/9; border-radius: 6px; overflow: hidden; margin-bottom: 8px; }
.lp-root .lp-heat-play {
  position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%);
  width: 40px; height: 40px; border-radius: 50%; background: rgba(255,255,255,0.9);
  color: #0A1018 !important; display: grid; place-items: center; font-size: 14px; z-index: 3;
}
.lp-root .lp-heat-blob { position: absolute; border-radius: 50%; filter: blur(12px); mix-blend-mode: screen; }
.lp-root .lp-heat-blob-1 { top: 20%; left: 30%; width: 60px; height: 60px; background: var(--lp-orange); opacity: 0.8; }
.lp-root .lp-heat-blob-2 { top: 60%; left: 60%; width: 40px; height: 40px; background: var(--lp-red); opacity: 0.7; }
.lp-root .lp-heat-blob-3 { top: 40%; left: 70%; width: 50px; height: 50px; background: var(--lp-gold); opacity: 0.6; }
.lp-root .lp-heat-timeline { display: flex; gap: 2px; align-items: flex-end; height: 30px; }
.lp-root .lp-heat-bar { flex: 1; background: var(--lp-orange); border-radius: 1px; min-height: 3px; }
.lp-root .lp-badge { position: absolute; padding: 10px 16px; border-radius: 10px; font-weight: 800; font-size: 13px; box-shadow: 0 12px 30px rgba(0,0,0,0.3); }
.lp-root .lp-badge-ret { top: -10px; right: 40px; background: #fff; color: #0A1018 !important; transform: rotate(4deg); }
.lp-root .lp-badge-rev { bottom: 40px; left: -20px; background: var(--lp-gold); color: #1a1405 !important; font-size: 12px; padding: 8px 14px; transform: rotate(-5deg); z-index: 3; }

/* ── LOGOS ── */
.lp-root .lp-logos {
  padding: 24px clamp(20px, 4vw, 60px);
  border-top: 1px solid rgba(255,255,255,0.06); border-bottom: 1px solid rgba(255,255,255,0.06);
  display: flex; align-items: center; gap: 40px; justify-content: center;
  font-size: 12px; color: rgba(255,255,255,0.35); flex-wrap: wrap;
}
.lp-root .lp-logos-label { letter-spacing: 0.3px; }
.lp-root .lp-logo-brand { font-weight: 900; font-size: 18px; color: rgba(255,255,255,0.55); letter-spacing: 0.5px; }

/* ── SECTIONS ── */
.lp-root .lp-section { padding: 80px clamp(20px, 4vw, 60px); }
.lp-root .lp-section-alt { background: var(--lp-bg-2) !important; }
.lp-root .lp-section-head { text-align: center !important; margin-bottom: 44px; }

.lp-root .lp-pill {
  display: inline-block; padding: 6px 14px; border-radius: 999px;
  font-size: 12px; font-weight: 800; text-transform: uppercase;
  letter-spacing: 0.2px; margin-bottom: 14px;
}
.lp-root .lp-pill-red   { background: rgba(255,90,107,0.12);  border: 1px solid rgba(255,90,107,0.3);  color: var(--lp-red) !important; }
.lp-root .lp-pill-orange{ background: rgba(232,106,16,0.12);  border: 1px solid rgba(232,106,16,0.3);  color: var(--lp-orange) !important; }
.lp-root .lp-pill-gold  { background: rgba(245,185,53,0.14);  border: 1px solid rgba(245,185,53,0.3);  color: var(--lp-gold) !important; }
.lp-root .lp-pill-green { background: rgba(40,199,111,0.12);  border: 1px solid rgba(40,199,111,0.3);  color: var(--lp-green) !important; }

.lp-root .lp-h2 {
  font-size: clamp(28px, 4vw, 42px) !important;
  font-weight: 900 !important;
  letter-spacing: -1.2px;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: auto !important;
  margin-right: auto !important;
  line-height: 1.1 !important;
  max-width: 780px;
  color: var(--lp-text) !important;
  text-align: center !important;
  display: block;
  width: 100%;
}
.lp-root .lp-section-sub { color: var(--lp-text-dim); font-size: 15px; margin: 10px 0 0; }

.lp-root .lp-grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px; }
@media (max-width: 900px) { .lp-root .lp-grid-3 { grid-template-columns: 1fr; } }

.lp-root .lp-card {
  background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08);
  border-radius: 14px; padding: 28px; position: relative; overflow: hidden;
}
.lp-root .lp-card-feat { border-color: rgba(232,106,16,0.4); }
.lp-root .lp-card-prob .lp-card-bignum {
  position: absolute; top: -8px; right: -4px; font-size: 100px; font-weight: 900;
  color: rgba(255,255,255,0.04); letter-spacing: -3px; pointer-events: none;
}
.lp-root .lp-card-icon { width: 44px; height: 44px; border-radius: 12px; display: grid; place-items: center; font-size: 18px; font-weight: 900; margin-bottom: 16px; }
.lp-root .lp-icon-red { background: rgba(255,90,107,0.12); border: 1px solid rgba(255,90,107,0.2); color: var(--lp-red) !important; }
.lp-root .lp-step-num {
  width: 48px; height: 48px; border-radius: 12px;
  background: linear-gradient(135deg, var(--lp-orange), var(--lp-gold));
  display: grid; place-items: center; color: #1a1405 !important;
  font-size: 22px; font-weight: 900; margin-bottom: 16px;
}
.lp-root .lp-card-title { font-size: 19px; font-weight: 800 !important; margin: 0 0 8px; color: var(--lp-text) !important; }
.lp-root .lp-card-body  { font-size: 14px; line-height: 1.55; color: var(--lp-text-mute); margin: 0; }

/* ── TESTIMONIALS ── */
.lp-root .lp-t-head { display: flex; align-items: center; gap: 12px; margin-bottom: 18px; }
.lp-root .lp-t-avatar { width: 44px; height: 44px; border-radius: 50%; display: grid; place-items: center; color: #fff !important; font-weight: 900; font-size: 16px; }
.lp-root .lp-t-name  { font-weight: 800; font-size: 14px; color: var(--lp-text) !important; }
.lp-root .lp-t-role  { font-size: 12px; color: var(--lp-text-dim); }
.lp-root .lp-t-stars { margin-left: auto; color: var(--lp-gold) !important; font-size: 12px; letter-spacing: 1px; }
.lp-root .lp-t-metric { padding: 12px 14px; background: rgba(40,199,111,0.08); border: 1px solid rgba(40,199,111,0.2); border-radius: 10px; margin-bottom: 16px; display: flex; align-items: baseline; gap: 8px; }
.lp-root .lp-t-metric-v { font-size: 24px; font-weight: 900; color: var(--lp-green) !important; letter-spacing: -0.5px; }
.lp-root .lp-t-metric-l { font-size: 12px; color: rgba(255,255,255,0.65); }
.lp-root .lp-t-quote { font-size: 14px; line-height: 1.6; color: rgba(255,255,255,0.78); margin: 0; }

/* ── PRICING ── */
.lp-root .lp-pricing { display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px; max-width: 1100px; margin: 0 auto; }
@media (max-width: 900px) { .lp-root .lp-pricing { grid-template-columns: 1fr; } }
.lp-root .lp-price-card { background: rgba(255,255,255,0.03); border: 1.5px solid rgba(255,255,255,0.08); border-radius: 18px; padding: 30px; position: relative; }
.lp-root .lp-price-feat { background: linear-gradient(180deg, rgba(232,106,16,0.08), rgba(232,106,16,0.02)) !important; border-color: var(--lp-orange); box-shadow: 0 20px 60px rgba(232,106,16,0.15); }
.lp-root .lp-price-badge { position: absolute; top: -13px; left: 50%; transform: translateX(-50%); background: linear-gradient(90deg, var(--lp-orange), var(--lp-gold)); color: #1a1405 !important; font-size: 11px; font-weight: 900; padding: 5px 16px; border-radius: 999px; letter-spacing: 0.3px; white-space: nowrap; }
.lp-root .lp-price-name { margin: 0 0 6px; font-size: 18px; font-weight: 800 !important; color: var(--lp-text) !important; }
.lp-root .lp-price-old  { font-size: 12px; color: var(--lp-text-dim); text-decoration: line-through; }
.lp-root .lp-price-value { margin: 4px 0 18px; display: flex; align-items: baseline; gap: 4px; }
.lp-root .lp-price-curr { font-size: 16px; color: var(--lp-text-mute); font-weight: 700; }
.lp-root .lp-price-num  { font-size: 52px; font-weight: 900; letter-spacing: -2.5px; color: var(--lp-text) !important; }
.lp-root .lp-price-per  { font-size: 14px; color: var(--lp-text-dim); }
.lp-root .lp-price-feats { list-style: none; padding: 0; margin: 0 0 22px; display: flex; flex-direction: column; gap: 9px; }
.lp-root .lp-price-feats li { font-size: 13.5px; color: var(--lp-text-mute); display: flex; gap: 8px; }
.lp-root .lp-check { color: var(--lp-green) !important; font-weight: 900; }
.lp-root .lp-price-cta { display: block; padding: 14px 0; background: transparent !important; color: #fff !important; border: 1.5px solid rgba(255,255,255,0.2) !important; border-radius: 10px; font-weight: 800; text-align: center; font-size: 14px; transition: border-color 0.15s, background 0.15s; }
.lp-root .lp-price-cta:hover { border-color: rgba(255,255,255,0.4) !important; background: rgba(255,255,255,0.03) !important; }
.lp-root .lp-price-feat .lp-price-cta { background: linear-gradient(90deg, var(--lp-orange), var(--lp-orange-deep)) !important; border: none !important; box-shadow: 0 10px 28px rgba(232,106,16,0.4); }

/* ── FAQ ── */
.lp-root .lp-faq-grid { display: grid; grid-template-columns: 340px 1fr; gap: 60px; max-width: 1200px; margin: 0 auto; }
@media (max-width: 900px) { .lp-root .lp-faq-grid { grid-template-columns: 1fr; gap: 32px; } }
.lp-root .lp-faq-sub { font-size: 14.5px; line-height: 1.6; color: var(--lp-text-mute); margin: 16px 0 0; }
.lp-root .lp-faq-list { display: flex; flex-direction: column; gap: 12px; }
.lp-root .lp-faq-item { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 18px 22px; cursor: pointer; }
.lp-root .lp-faq-item summary { list-style: none; display: flex; align-items: center; justify-content: space-between; font-size: 15px; font-weight: 700; color: #fff !important; }
.lp-root .lp-faq-item summary::-webkit-details-marker { display: none; }
.lp-root .lp-faq-plus { color: var(--lp-gold) !important; font-size: 20px; font-weight: 400; transition: transform 0.2s; }
.lp-root .lp-faq-item[open] .lp-faq-plus { transform: rotate(45deg); }
.lp-root .lp-faq-item p { font-size: 14px; line-height: 1.6; color: rgba(255,255,255,0.65); margin: 12px 0 0; }

/* ── FINAL CTA ── */
.lp-root .lp-final { padding: 80px clamp(20px, 4vw, 60px) 100px; text-align: center !important; position: relative; overflow: hidden; }
.lp-root .lp-final-glow { position: absolute; inset: 0; background: radial-gradient(ellipse at center, rgba(232,106,16,0.2), transparent 60%); pointer-events: none; }
.lp-root .lp-final-inner { position: relative; }
.lp-root .lp-final-h { font-size: clamp(36px, 5vw, 54px) !important; font-weight: 900 !important; letter-spacing: -2px; line-height: 1 !important; margin: 0 0 16px !important; color: var(--lp-text) !important; }
.lp-root .lp-final-sub { font-size: 17px; color: var(--lp-text-mute); margin: 0 0 28px; }

/* ── FOOTER ── */
.lp-root .lp-footer { padding: 40px clamp(20px, 4vw, 60px); border-top: 1px solid rgba(255,255,255,0.06); display: flex; justify-content: space-between; align-items: center; font-size: 12px; color: var(--lp-text-dim); flex-wrap: wrap; gap: 16px; }
.lp-root .lp-footer-brand { display: flex; align-items: center; gap: 10px; color: var(--lp-text-dim); }
.lp-root .lp-footer-links { display: flex; gap: 22px; }
.lp-root .lp-footer-links a:hover { color: #fff !important; }

/* ── MÓDULOS / A SOLUÇÃO ── */
.lp-root .lp-mods-tabs { display: flex; gap: 10px; justify-content: center; margin-bottom: 28px; flex-wrap: wrap; }
.lp-root .lp-mods-tab {
  display: flex; flex-direction: column; align-items: center; gap: 8px;
  padding: 14px 18px; background: rgba(255,255,255,0.02);
  border: 1.5px solid rgba(255,255,255,0.08); border-radius: 14px;
  cursor: pointer; min-width: 108px; color: inherit; font-family: inherit;
  transition: all 0.15s;
}
.lp-root .lp-mods-tab.active { background: rgba(255,255,255,0.04); }
.lp-root .lp-mods-tab-icon { width: 34px; height: 34px; border-radius: 8px; border: 1px solid; display: grid; place-items: center; font-size: 16px; }
.lp-root .lp-mods-tab-name { font-size: 10.5px; font-weight: 800; letter-spacing: 0.4px; color: rgba(255,255,255,0.55); text-align: center; }
.lp-root .lp-mods-tab-name.active { color: #fff !important; }

.lp-root .lp-mods-panel { max-width: 1100px; margin: 0 auto; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 20px; padding: 44px; display: grid; grid-template-columns: 1.05fr 1fr; gap: 40px; align-items: center; position: relative; overflow: hidden; }
.lp-root .lp-mods-glow { position: absolute; top: -80px; right: -80px; width: 280px; height: 280px; border-radius: 50%; pointer-events: none; }
.lp-root .lp-mods-content { position: relative; }
.lp-root .lp-mods-pill { display: inline-block; padding: 4px 12px; border: 1px solid; border-radius: 999px; font-size: 11px; font-weight: 800; letter-spacing: 0.4px; margin-bottom: 16px; }
.lp-root .lp-mods-title { font-size: 28px !important; font-weight: 900 !important; letter-spacing: -0.8px; margin: 0 0 14px !important; line-height: 1.15 !important; color: var(--lp-text) !important; }
.lp-root .lp-mods-desc { font-size: 14.5px; line-height: 1.6; color: rgba(255,255,255,0.7); margin: 0 0 22px; }
.lp-root .lp-mods-bullets { list-style: none; padding: 0; margin: 0 0 22px; display: flex; flex-direction: column; gap: 9px; }
.lp-root .lp-mods-bullets li { display: flex; gap: 10px; font-size: 13.5px; color: rgba(255,255,255,0.82); line-height: 1.5; }
.lp-root .lp-mods-check { font-weight: 900; flex-shrink: 0; }
.lp-root .lp-mods-footer { display: inline-flex; align-items: center; gap: 8px; padding: 10px 14px; border: 1px solid; border-radius: 10px; font-size: 12.5px; font-weight: 700; color: rgba(255,255,255,0.9); }

.lp-root .lp-mods-mockup-wrap { position: relative; display: flex; justify-content: center; }
.lp-root .lp-mods-mockup { width: 100%; max-width: 360px; background: #0F1724; border: 1px solid rgba(255,255,255,0.08); border-radius: 14px; overflow: hidden; box-shadow: 0 20px 50px rgba(0,0,0,0.4); }
.lp-root .lp-mods-mockup-bar { padding: 14px 18px; display: flex; align-items: center; gap: 10px; font-weight: 800; font-size: 14px; }
.lp-root .lp-mods-mockup-icon { font-size: 16px; }
.lp-root .lp-mods-mockup-body { padding: 22px 20px 24px; }
.lp-root .lp-mods-bars { display: flex; flex-direction: column; gap: 8px; margin-bottom: 22px; }
.lp-root .lp-mods-bar { height: 10px; border-radius: 3px; }
.lp-root .lp-mods-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; padding-top: 14px; border-top: 1px solid rgba(255,255,255,0.06); }
.lp-root .lp-mods-stat { text-align: center; }
.lp-root .lp-mods-stat-v { font-size: 20px; font-weight: 900; letter-spacing: -0.5px; }
.lp-root .lp-mods-stat-l { font-size: 9px; font-weight: 800; color: rgba(255,255,255,0.5); letter-spacing: 0.5px; margin-top: 2px; }

@media (max-width: 900px) {
  .lp-root .lp-mods-panel { grid-template-columns: 1fr; padding: 28px; }
  .lp-root .lp-mods-title { font-size: 22px !important; }
}
</style>
